import { Dictionary } from '@/src/lib/dictionary/types.ts';
import { CategoryNode } from '@/src/lib/category/types.ts';

export function isAllProductsUrl(slug: Array<string>, dict: Dictionary) {
  const decodedSlug = slug.map(decodeURI);
  return [...decodedSlug].pop() === dict.category.allProductsSlug;
}

export function isSearchUrl(slug: Array<string>) {
  const decodedSlug = slug.map(decodeURI);
  return decodedSlug?.includes('search');
}

export function getTitle(
  slug: Array<string>,
  dict: Dictionary,
  categoryData: CategoryNode | undefined,
  searchParams?: { [key: string]: string | Array<string> | undefined },
) {
  if (searchParams?.q?.length) {
    return `"${Array.isArray(searchParams.q) ? searchParams.q.join(' ') : searchParams.q}"`;
  }

  if (isAllProductsUrl(slug, dict)) {
    return dict.category.allProducts;
  }

  return categoryData?.name || '';
}

export function getSubtitle(dict: Dictionary, searchParams?: { [key: string]: string | Array<string> | undefined }) {
  if (searchParams?.q?.length) {
    return dict.search.pageSubtitle;
  }

  return '';
}
